import React from 'react';
import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';
import { ResponsiveDialog } from '@zvuk-b2b/ui-kit';
import { AdCampaignMediaTypeEnum } from '@shared/api/graphql/generated';
import MediaUploadContent from './MediaUploadContent';
import { useAdCampaignMediaViewModel } from './useAdCampaignMediaViewModel';
import { AdCampaignStepperMediaProps } from './types';
import { TEXTS } from './texts';
import { ELEMENT_IDS } from './consts';
import dialogStyles from '../../AdCampaignMedia/dialog.module.scss';

const AdCampaignStepperMedia: React.FC<AdCampaignStepperMediaProps> = ({
  mediaType = AdCampaignMediaTypeEnum.Audio,
  onBack,
  onNext,
  close,
  promoState,
  timeById,
  durationById,
  onDurationChange,
  onTimeChange,
  onTimeRemove,
}) => {
  const {
    inputRef,
    isExactTime,
    isDraggable,
    acceptValue,
    uploadButtonText,
    uploadDescription,
    items,
    player,
    mediaUploadItems,
    isUploadDisabled,
    isNextDisabled,
    handleUploadClick,
    handleFilesChange,
    handleFilesSelected,
    handleRemoveClick,
    handleRetryClick,
    handleRemoveMedia,
    handleRetryMedia,
    handlePlayClick,
    handleTimeBlur,
    reorder,
  } = useAdCampaignMediaViewModel({ mediaType, promoState, timeById, durationById, onTimeChange, onTimeRemove });

  return (
    <ResponsiveDialog
      data-testid="modal_screen"
      open
      width={750}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) close?.();
      }}
      contentClassName={dialogStyles.container}>
      <div className={dialogStyles.headerCard}>
        <ResponsiveDialog.Header className={dialogStyles.title}>{TEXTS.TITLE}</ResponsiveDialog.Header>
        <ResponsiveDialog.Close
          id="button_modal_screen_close"
          className={dialogStyles.closeButton}
        />
      </div>
      <ResponsiveDialog.Body className={dialogStyles.content}>
        <MediaUploadContent
          inputRef={inputRef}
          isExactTime={isExactTime}
          isDraggable={isDraggable}
          acceptValue={acceptValue}
          uploadButtonText={uploadButtonText}
          uploadDescription={uploadDescription}
          items={items}
          player={player}
          mediaUploadItems={mediaUploadItems}
          isUploadDisabled={isUploadDisabled}
          handleUploadClick={handleUploadClick}
          handleFilesChange={handleFilesChange}
          handleFilesSelected={handleFilesSelected}
          handleRemoveClick={handleRemoveClick}
          handleRetryClick={handleRetryClick}
          handleRemoveMedia={handleRemoveMedia}
          handleRetryMedia={handleRetryMedia}
          handlePlayClick={handlePlayClick}
          handleTimeBlur={handleTimeBlur}
          reorder={reorder}
          mediaType={mediaType}
          timeById={timeById}
          durationById={durationById}
          onDurationChange={onDurationChange}
          onTimeChange={onTimeChange}
        />
      </ResponsiveDialog.Body>
      <ResponsiveDialog.Footer className={dialogStyles.footerCard}>
        <Button
          elementId={ELEMENT_IDS.BACK}
          type={ButtonType.SECONDARY}
          className={dialogStyles.footerButton}
          onClick={onBack}>
          {TEXTS.BACK}
        </Button>
        <Button
          elementId={ELEMENT_IDS.NEXT}
          type={ButtonType.PRIMARY}
          isDisabled={isNextDisabled}
          className={dialogStyles.footerButton}
          onClick={onNext}>
          {TEXTS.NEXT}
        </Button>
      </ResponsiveDialog.Footer>
    </ResponsiveDialog>
  );
};

export default AdCampaignStepperMedia;
